//OLD
import appliedPromotionalCode3months from './old_lotties/appliedPromotionalCode3months.json';
import appliedPromotionalCode12months from './old_lotties/appliedPromotionalCode12months.json';
import starterPlanAppliedPromotionalCode from './old_lotties/starterPlanAppliedPromotionalCode.json';
import starterPlanIntegratedSolutionAppliedPromotionalCode from './old_lotties/starterPlanIntegratedSolutionAppliedPromotionalCode.json';
import totalPlanAppliedPromotionalCode from './old_lotties/totalPlanAppliedPromotionalCode.json';
import totalPlanIntegratedSolutionAppliedPromotionalCode from './old_lotties/totalPlanIntegratedSolutionAppliedPromotionalCode.json';
//NEW
import standardPlan from './standard.json';
import premiumPlan from './premium.json';
import promo3Months from './promo3Months.json';
import promo6Months from './promo6Months.json';
import promo9Months from './promo9Months.json';
import promo12Months from './promo12Months.json';
import promo18Months from './promo18Months.json';
import promo24Months from './promo24Months.json';
import promo36Months from './promo36Months.json';

export const animations = {
	appliedPromotionalCode3months,
	appliedPromotionalCode12months,
	starterPlanAppliedPromotionalCode,
	starterPlanIntegratedSolutionAppliedPromotionalCode,
	totalPlanAppliedPromotionalCode,
	totalPlanIntegratedSolutionAppliedPromotionalCode,
	standardPlan,
	premiumPlan,
	promo3Months,
	promo6Months,
	promo9Months,
	promo12Months,
	promo18Months,
	promo24Months,
	promo36Months,
};
